import { Alert, Box, Button } from '@mui/material';
import { FP, PageHeader } from 'components/financepro';
import { VERSION_NO_FISCAL, useVersionContable } from './versionContable';

/** Envuelve las pantallas que registran: en versión fiscal (solo consulta)
 *  muestran un aviso en vez del formulario. El backend también lo rechaza. */
export default function SoloNoFiscal({ titulo, children }) {
  const { soloConsulta, soloFiscal, cambiarVersion } = useVersionContable();
  if (!soloConsulta) return children;
  return (
    <Box component="main" sx={{ minHeight: '100vh', bgcolor: FP.color.surface }}>
      <PageHeader title={titulo} subtitle="Versión fiscal" />
      <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
        <Alert
          severity="info"
          action={
            !soloFiscal && (
              <Button color="inherit" size="small" onClick={() => cambiarVersion(VERSION_NO_FISCAL)}>
                Ir a no fiscal
              </Button>
            )
          }
        >
          La versión fiscal es solo de consulta. Todo se registra en la versión no fiscal y luego
          se pasa a fiscal.
        </Alert>
      </Box>
    </Box>
  );
}
